import { __awaiter } from "tslib";
import { currentTime } from "../stores/player";
import { currentSegmentIdx, currentFrameDetection } from "../stores/segment";
import { segments } from "../constants/segments";
let frames = [];
let segmentIdx = 0;
let frameIdx = 0;
currentSegmentIdx.subscribe((idx) => __awaiter(void 0, void 0, void 0, function* () {
    segmentIdx = idx;
    if (frames.length === 0) {
        for (let i = 0; i < segments.length; i++) {
            console.time(`fetch[${i + 1}]`);
            const data = yield (yield fetch(segments[i].url)).json();
            console.timeEnd(`fetch[${i + 1}]`);
            frames.push(data);
        }
    }
    frameIdx = 0;
    currentFrameDetection.set(undefined);
    currentTime.set(segments[idx].start);
}));
currentTime.subscribe(time => {
    if (segmentIdx >= frames.length || frames[segmentIdx].length === 0) {
        currentFrameDetection.set(undefined);
        return;
    }
    let d = frames[segmentIdx];
    let t = time * 1000;
    for (; frameIdx < d.length - 1 && d[frameIdx].timestamp < t; frameIdx++)
        ;
    for (; frameIdx > 0 && d[frameIdx].timestamp > t; frameIdx--)
        ;
    frameIdx = Math.min(frameIdx + 1, d.length - 1);
    if (Math.abs(d[frameIdx].timestamp - t) > 200) {
        currentFrameDetection.set(undefined);
        return;
    }
    currentFrameDetection.set(d[frameIdx]);
});
